export const serviceTypes = [
  { value: "Cleaning", label: "Cleaning" },
  { value: "Carpet Cleaning", label: "Carpet Cleaning" },
  { value: "Office Cleaning", label: "Office Cleaning" },
  { value: "Window Cleaning", label: "Window Cleaning" },
  { value: "Deep Cleaning", label: "Deep Cleaning" },
  { value: "Other", label: "Other" },
];